import { DateTimeUtils, StringUtils, TIME_FORMAT } from '@localina/core';
import { CalendarIcon, ClockIcon, HouseWithDots, PeopleIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IApplicationStore } from '../../interfaces';

export interface ISummaryRow {
    key: string;
    icon: React.ReactNode;
    label: string;
    value: React.ReactNode;
}

interface IProps {
    rows: ISummaryRow[];
    className?: string;
}

export const SummaryCard: React.FC<IProps> = (props) => (
    <dl className={StringUtils.combineStrings(['widget-summary', props.className])}>
        {props.rows.map((row) => (
            <div key={row.key} className={StringUtils.combineStrings(['widget-summary__row', row.key])}>
                <dt>
                    {row.icon}
                    <span>{row.label}</span>
                </dt>
                <dd>{row.value}</dd>
            </div>
        ))}
    </dl>
);

// Date, time, party size and area of the booking in progress, as shown on the review and done steps.
export const ReservationSummaryCard: React.FC = () => {
    const { t } = useTranslation();
    const reservation = useSelector((state: IApplicationStore) => state.reservation.datetime);
    const shifts = useSelector((state: IApplicationStore) => state.restaurant.availableShifts);

    const areaName = shifts.flatMap((shift) => shift.areas).find((area) => area.id === reservation.areaId)?.name;

    const rows: ISummaryRow[] = [
        { key: 'date', icon: <CalendarIcon />, label: t('reservation.fields.date'), value: reservation.date },
        {
            key: 'time',
            icon: <ClockIcon />,
            label: t('reservation.fields.time'),
            value: DateTimeUtils.getTimeFromDateTime(reservation.date, reservation.time).toFormat(TIME_FORMAT),
        },
        { key: 'people', icon: <PeopleIcon />, label: t('reservation.fields.people'), value: reservation.participants },
    ];
    if (areaName) {
        rows.push({ key: 'area', icon: <HouseWithDots />, label: t('reservation.fields.area'), value: areaName });
    }

    return <SummaryCard className="datetime" rows={rows} />;
};
